import { useEffect, useState } from "react";
import axios from "axios";
import { Form, Col, Tooltip, OverlayTrigger } from "react-bootstrap";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";

function InputFields(props) {
  const [data, setData] = useState([]);
  const [years, setYears] = useState([]);
  const [textValue, setTextValue] = useState(
    Object.byString(props.values, props.name) === null
      ? ""
      : Object.byString(props.values, props.name)
  );
  const getData = async () => {
    await axios.get(props.config.apiEndpoint).then((res) => {
      setData(res.data);
    });
  };

  useEffect(() => {
    if (props.values[props.name] === "")
      resetTextValue();
  }, [props.values[props.name]])

  const resetTextValue = async () => {
    setTextValue("");
  }

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "solid red 1px",
    }),
  };

  useEffect(() => {
    async function setApiData() {
      if (props.config.hasApi) {
        await getData();
      } else {
        setData(props.config.data);
      }
    }
    setApiData();
  }, []);

  useEffect(() => {
    if (props.config.type === "year" || props.config.type === "prevYears") {
      let d = new Date();
      let n = d.getFullYear();
      if (props.config.type === "prevYears") n = n - 1;
      let yearArr = [];

      let yearStart = 1993;
      if(props.config.yearStart !== undefined){
        yearStart = props.config.yearStart;
      }
      let yearEnd = n;
      Array(yearEnd - yearStart + 1)
        .fill()
        .forEach(() => {
          let y = yearStart++;
          yearArr.push({ label: y, value: y });
        });

      setYears(yearArr.reverse());
    }
  }, []);

  const onTextChange = (e) => {
    setTextValue(e.target.value);
  }

  const onTextBlur = (e) => {
    props.setFieldValue(props.name, textValue);
    return Promise.resolve();
  }

  const onEnterPress = (e) => {
    if (e.charCode === 13) {
      onTextBlur().then(response => {
        props.handleSubmit(e);
      });
    }
  };

  switch (props.config.type) {
    case "select":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Form.Control
            name={props.name}
            placeholder={props.config.placeholder}
            value={props.values[props.name]}
            onChange={props.handleChange}
            isInvalid={!!props.errors[props.name]}
            as="select"
            // defaultValue={props.initialFormValues[props.name]}
            custom
          >
            <option value=""></option>
            {data.map((d, i) => (
              <option key={d.value} value={d.value}>
                {d.label}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "select2":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Select
            options={data}
            isMulti={false}
            isClearable={props.values[props.name] !== ""}
            value={props.values[props.name]}
            onChange={(e) => {
              if (e) {
                props.setFieldValue(props.name, e);
              }
            }}
            styles={
              props.errors[props.name]
                ? customStyles
                : props.config.customStyles
                  ? props.config.customStyles
                  : {
                    control: (base) => ({
                      ...base,
                      borderRadius: 0,
                      height: "10px",
                      lineHeight: 1.3,
                      fontSize: "1rem",
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "1rem",
                    }),
                  }
            }
            isDisabled={props.readOnly}
            autoSize={true}
          />
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "select3":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <WindowedSelect
            options={data}
            isClearable={props.values[props.name] !== ""}
            isMulti={false}
            isRTL={true}
            value={
              typeof props.values[props.name] === "object"
                ? props.values[props.name]
                : {
                  value: Object.byString(props.values, props.name),
                  label: data.find(
                    ({ value }) =>
                      value === Object.byString(props.values, props.name)
                  )
                    ? data.find(
                      ({ value }) =>
                        value ===
                        Object.byString(props.values, props.name)
                    ).label
                    : Object.byString(props.values, props.name),
                }
            }
            onChange={(e, { action }) => {
              if (action === "clear") {
                props.setFieldValue(props.name, "");
              } else {
                props.setFieldValue(props.name, e.value);
              }
            }}
            styles={
              props.errors[props.name]
                ? customStyles
                : props.config.customStyles
                  ? props.config.customStyles
                  : {
                    control: (base) => ({
                      ...base,
                      borderRadius: 0,
                      height: "10px",
                      lineHeight: 1.3,
                      fontSize: "1rem",
                    }),
                  }
            }
            isDisabled={props.readOnly}
            autoSize={true}
          />
          {/* <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback> */}
          <div
            style={{ fontSize: "80%", color: "#dc3545", marginTop: "0.25rem" }}
          >
            {props.errors[props.name]}
          </div>
        </Form.Group>
      );
    case "year":
    case "prevYears":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Select
            options={years.map((y, i) => ({ label: y.label, value: y.value }))}
            isClearable={props.values[props.name] !== ""}
            isMulti={false}
            value={{
              label: props.values[props.name],
              value: props.values[props.name],
            }}
            onChange={(e, { action }) => {
              if (action === "clear") {
                props.setFieldValue(props.name, "");
              } else {
                props.setFieldValue(props.name, e.value);
              }
            }}
            styles={
              props.errors[props.name]
                ? customStyles
                : props.config.customStyles
                  ? props.config.customStyles
                  : {
                    control: (base) => ({
                      ...base,
                      borderRadius: 0,
                      height: "10px",
                      lineHeight: 1.3,
                      fontSize: "1rem",
                    }),
                  }
            }
            isDisabled={props.readOnly}
            autoSize={true}
          />
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "multi-select":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Select
            options={data}
            isMulti={true}
            value={props.values[props.name]}
            onChange={(e, { action }) => {
              if (action === "clear") {
                props.setFieldValue(props.name, []);
              } else if (action === "remove-value") {
                if (props.values[props.name].length === 1) {
                  props.setFieldValue(props.name, []);
                } else {
                  props.setFieldValue(props.name, e);
                }
              } else {
                props.setFieldValue(props.name, e);
              }
            }}
            styles={
              props.errors[props.name]
                ? customStyles
                : props.config.customStyles
                  ? props.config.customStyles
                  : {
                    control: (base) => ({
                      ...base,
                      borderRadius: 0,
                      //height: "10px",
                      //lineHeight: 1.3,
                      fontSize: "1rem",
                    }),
                  }
            }
          />
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
          <div
            style={{ fontSize: "80%", color: "#dc3545", marginTop: "0.25rem" }}
          >
            {props.errors[props.name]}
          </div>
        </Form.Group>
      );
    case "text":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Form.Control
            type="text"
            placeholder={props.config.placeholder}
            name={props.name}
            value={textValue}
            onChange={onTextChange}
            onBlur={onTextBlur}
            onKeyPress={(e) => onEnterPress(e)}
            readOnly={props.readOnly}
            isInvalid={props.errors[props.name]}
          />
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "date":
      return (
        <Form.Group
          as={Col}
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          controlId={`formikValidation-${props.name}`}
          className={props.config.formGroupClass}
        >
          {props.config.info ? (
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="info-tooltip">{props.config.info}</Tooltip>}
            >
              <Form.Label style={{ color: "#046b99", cursor: "help" }}>{props.config.label}</Form.Label>
            </OverlayTrigger>
          ) : <Form.Label>{props.config.label}</Form.Label>}

          {props.validationSchema &&
            props.validationSchema.describe().fields[props.name] &&
            (props.validationSchema
              .describe()
              .fields[props.name].tests.find((o) => o.name === "required") ||
              (props.validationSchema.fields[props.name]._conditions.length &&
                props.values[
                props.validationSchema.fields[props.name]._conditions[0].refs[0]
                  .key
                ]) === "") ? (
              <span
                className="ml-1"
                style={{ color: "red" }}
                title="This field is Required"
              >
                *
              </span>
            ) : null}
          <Form.Control
            type="date"
            placeholder={props.config.placeholder}
            name={props.name}
            value={props.values[props.name]}
            onChange={props.handleChange}
            isInvalid={!!props.errors[props.name]}
          />
          <Form.Control.Feedback type="invalid">
            {props.errors[props.name]}
          </Form.Control.Feedback>
        </Form.Group>
      );
    case "custom":
      // only used by CorrectionLetterManifestReport?
      return (
        <Col
          {...(props.config.col === "xs" && { xs: props.config.colWidth })}
          {...(props.config.col === "sm" && { sm: props.config.colWidth })}
          {...(props.config.col === "md" && { md: props.config.colWidth })}
          {...(props.config.col === "lg" && { lg: props.config.colWidth })}
          {...(props.config.col === "xl" && { xl: props.config.colWidth })}
          className={props.config.formGroupClass}
        >
          <div>{props.config.text}</div>
        </Col>
      );
    default:
      return (<p>Invalid type: {props.config.type}</p>);
  }
}

export default InputFields;
